import { render, staticRenderFns } from "./PLFarmacias.vue?vue&type=template&id=66326efa&scoped=true&"
import script from "./PLFarmacias.vue?vue&type=script&lang=js&"
export * from "./PLFarmacias.vue?vue&type=script&lang=js&"
import style0 from "./PLFarmacias.vue?vue&type=style&index=0&id=66326efa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66326efa",
  null
  
)

export default component.exports